<script lang="ts">
  import { storyblokEditable } from "@storyblok/svelte";
  import { parseUrl } from "$lib/utils/helpers.js";

  // Get the block data
  export let blok;

  // Get the block alignment
  const align = blok.align || "left";
</script>

<div
  class:appstore-buttons={true}
  class:align-left={align === "left"}
  class:align-center={align === "center"}
  class:align-right={align === "right"}
  use:storyblokEditable={blok}
>
  <a href={parseUrl(blok.appStoreLink)} class="appstore-button"
    ><img
      class="appstore-button"
      src="https://a-us.storyblok.com/f/1003963/119x40/d811a0f29f/apple-app-store-badge.svg"
      alt="Download on the App Store"
    /></a
  >
  <a href={parseUrl(blok.playStoreLink)} class="appstore-button"
    ><img
      class="appstore-button"
      src="https://a-us.storyblok.com/f/1003963/180x53/dca335581e/google-play-badge.svg"
      alt="Get it on Google Play"
    /></a
  >
</div>

<style lang="postcss">
  .appstore-buttons {
    display: flex;
    gap: 1rem;

    @screen md {
      gap: 2rem;
    }

    &.align-left {
      justify-content: flex-start;
    }

    &.align-center {
      justify-content: center;
    }

    &.align-right {
      justify-content: flex-end;
    }
  }

  .appstore-button {
    height: 50px;
  }
</style>
